import { debounce } from 'lib-utils'

let currentWidth = window.innerWidth
window.addEventListener(
  'resize',
  debounce(() => {
    const newWidth = window.innerWidth
    if (currentWidth !== newWidth) {
      const resizeEvent = new CustomEvent('nova:resize-width')
      window.dispatchEvent(resizeEvent)
      currentWidth = newWidth
    }
  }, 250)
)
if (screen.orientation) {
  screen.orientation.addEventListener('change', (event) => {
    debounce(() => {
      const resizeEvent = new CustomEvent('nova:resize-width')
      window.dispatchEvent(resizeEvent)
    }, 250)
  })
}
